import React, { ReactNode } from 'react'
import { InlineLink } from '../atoms'
import { TwitterIcon, LinkIcon } from '../../design-system'

interface ProfileLinkProps {
  value?: string
  children?: ReactNode
}

export const TwitterProfileLink = ({
  value,
  children = 'Twitter',
}: ProfileLinkProps) =>
  !value ? null : (
    <InlineLink
      to={'https://twitter.com/' + value}
      prefixView={<TwitterIcon width="1em" />}
    >
      {children}
    </InlineLink>
  )

export const WebsiteProfileLink = ({
  value,
  children = value && value.replace(/^https?:\/\//, ''),
}: ProfileLinkProps) =>
  !value ? null : (
    <InlineLink prefixView={<LinkIcon width="1em" />} to={value}>
      {children}
    </InlineLink>
  )
